document.addEventListener('DOMContentLoaded', () => {
  const cz = document.getElementById('jacket-customizer');
  if (!cz) return;

  const productForm = cz.closest('form');
  const totalSteps = Number(cz.dataset.totalSteps || 6);
  const steps = Array.from(cz.querySelectorAll('.cz-step'));
  const bar = cz.querySelector('.cz-progress__bar');

  let step = 1;
  const setProgress = () => {
    const pct = Math.max(0, Math.min(100, (step / totalSteps) * 100));
    if (bar) bar.style.width = `${pct}%`;
  };
  const showStep = (n) => {
    steps.forEach(s => s.hidden = Number(s.dataset.step) !== n);
    step = n;
    setProgress();
  };

  // Controls
  const nextBtns = cz.querySelectorAll('.cz-next');
  const prevBtns = cz.querySelectorAll('.cz-prev');
  const confirmBtn = cz.querySelector('.cz-confirm');

  // Size mode toggle
  const modeRadios = cz.querySelectorAll('input[name="cz-size-mode"]');
  const blockStandard = document.getElementById('block-standard');
  const blockCustom = document.getElementById('block-custom');
  const selectStandard = document.getElementById('cz-standard-size');
  const customFields = ['meas-chest','meas-shoulder','meas-sleeve','meas-back'].map(id => document.getElementById(id));

  const setMode = () => {
    const mode = cz.querySelector('input[name="cz-size-mode"]:checked').value;
    const isStandard = mode === 'Standard';
    blockStandard.hidden = !isStandard;
    blockCustom.hidden = isStandard;
    if (selectStandard) selectStandard.required = isStandard;
    customFields.forEach(f => f && (f.required = !isStandard));
  };
  modeRadios.forEach(r => r.addEventListener('change', setMode));
  setMode();

  // Validators per step
  const validators = {
    1: () => !!cz.querySelector('input[name="cz-leather"]:checked'),
    2: () => !!cz.querySelector('input[name="cz-lining"]:checked'),
    3: () => !!cz.querySelector('input[name="cz-hardware"]:checked'),
    4: () => !!cz.querySelector('input[name="cz-cuffs"]:checked'),
    5: () => {
      const mode = cz.querySelector('input[name="cz-size-mode"]:checked').value;
      if (mode === 'Standard') return !!selectStandard && !!selectStandard.value;
      return customFields.every(f => f && f.value && !isNaN(f.value));
    }
  };

  nextBtns.forEach(btn => btn.addEventListener('click', () => {
    if (!validators[step] || validators[step]()) showStep(step + 1);
  }));
  prevBtns.forEach(btn => btn.addEventListener('click', () => showStep(step - 1)));

  // Summary updater
  const updateSummary = () => {
    const getVal = (sel) => cz.querySelector(sel)?.value || '';
    const leather = cz.querySelector('input[name="cz-leather"]:checked')?.value || '';
    const lining = cz.querySelector('input[name="cz-lining"]:checked')?.value || '';
    const hardware = cz.querySelector('input[name="cz-hardware"]:checked')?.value || '';
    const cuffs = cz.querySelector('input[name="cz-cuffs"]:checked')?.value || '';
    const mode = cz.querySelector('input[name="cz-size-mode"]:checked')?.value || 'Standard';
    const sizeSummary = mode === 'Standard'
      ? `Standard ${selectStandard?.value || ''}`
      : `Custom (Chest ${getVal('#meas-chest')} / Shoulder ${getVal('#meas-shoulder')} / Sleeve ${getVal('#meas-sleeve')} / Back ${getVal('#meas-back')} cm)`;

    cz.querySelectorAll('[data-summary="leather"]').forEach(n => n.textContent = leather);
    cz.querySelectorAll('[data-summary="lining"]').forEach(n => n.textContent = lining);
    cz.querySelectorAll('[data-summary="hardware"]').forEach(n => n.textContent = hardware);
    cz.querySelectorAll('[data-summary="cuffs"]').forEach(n => n.textContent = cuffs);
    cz.querySelectorAll('[data-summary="size"]').forEach(n => n.textContent = sizeSummary);
  };
  cz.addEventListener('change', (e) => {
    if (e.target.matches('input, select')) updateSummary();
  });

  // Confirm → write hidden props → submit form
  if (confirmBtn) confirmBtn.addEventListener('click', () => {
    const leather = cz.querySelector('input[name="cz-leather"]:checked')?.value || '';
    const lining = cz.querySelector('input[name="cz-lining"]:checked')?.value || '';
    const hardware = cz.querySelector('input[name="cz-hardware"]:checked')?.value || '';
    const cuffs = cz.querySelector('input[name="cz-cuffs"]:checked')?.value || '';
    const mode = cz.querySelector('input[name="cz-size-mode"]:checked')?.value || 'Standard';

    document.getElementById('prop-leather').value = leather;
    document.getElementById('prop-lining').value = lining;
    document.getElementById('prop-hardware').value = hardware;
    document.getElementById('prop-cuffs').value = cuffs;
    document.getElementById('prop-size-mode').value = mode;

    if (mode === 'Standard') {
      document.getElementById('prop-standard-size').value = selectStandard?.value || '';
      document.getElementById('prop-chest').value = '';
      document.getElementById('prop-shoulder').value = '';
      document.getElementById('prop-sleeve').value = '';
      document.getElementById('prop-back-length').value = '';
    } else {
      document.getElementById('prop-standard-size').value = '';
      document.getElementById('prop-chest').value = document.getElementById('meas-chest').value;
      document.getElementById('prop-shoulder').value = document.getElementById('meas-shoulder').value;
      document.getElementById('prop-sleeve').value = document.getElementById('meas-sleeve').value;
      document.getElementById('prop-back-length').value = document.getElementById('meas-back').value;
    }

    updateSummary();

    if (productForm) {
      productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });

  updateSummary();
  showStep(1);
});